import React, { useContext } from 'react';
import {
  DropdownFilter,
  InputDropdown,
} from 'src/components/dropdown-filter/DropdownFilter';
import { useTranslation } from 'react-i18next';
import { ItemFilter } from 'src/components/dropdown-filter/filter';
import { CheckboxList } from 'src/components/dropdown-filter/CheckboxList';
import { ListContext } from '../context';
import { TransactionType } from '../../transaction';

export const FilterTransactionType = () => {
  const { dispatch, filters } = useContext(ListContext);

  const { t } = useTranslation();

  const items = [
    TransactionType.CREDIT,
    TransactionType.SALE,
    TransactionType.CASH_ADVANCE,
    TransactionType.CONDITIONAL_DEPOSIT_SALE,
    TransactionType.CONDITIONAL_DEPOSIT_CASH_ADVANCE,
    TransactionType.SALE_AUTH_REQUEST,
    TransactionType.CASH_ADVANCE_AUTH_REQUEST,
    TransactionType.AMERICAN_EXPRESS_AUTH_REQUEST,
    TransactionType.CARTE_BLANCHE_AUTH_REQUEST,
    TransactionType.DINERS_CLUB_AUTH_REQUEST,
    TransactionType.JBS_AUTH_REQUEST,
    TransactionType.PRIVATE_LABEL_AUTH_REQUEST,
    TransactionType.ACCOUNT_VERIFY_REQUEST,
    TransactionType.REGULAR_VOID,
    TransactionType.VOID_UNDELIVERED,
    TransactionType.VOID_REVERSAL,
  ].map((item) => ({
    value: item,
    label: t(`transactionsManagement.transactions.transactionType.${item}`),
  }));

  const itemToggle = (options: { checked: boolean; item: ItemFilter }) =>
    dispatch({
      type: options.checked
        ? 'ADD_TRANSACTION_TYPE_FILTER'
        : 'REMOVE_TRANSACTION_TYPE_FILTER',
      itemFilter: options.item,
    });

  const clearFilter = () => dispatch({ type: 'RESET_TRANSACTION_TYPE_FILTER' });

  return (
    <DropdownFilter
      title={t(
        'transactionsManagement.transactions.list.filters.transactionType'
      )}
      headerSecondaryLabel={t(
        'transactionsManagement.transactions.list.filters.numberSelected',
        { totalItems: filters.transactionTypes.length }
      )}
      onClearFilter={clearFilter}
      trigger={(dropdownProps) => (
        <InputDropdown
          name="filterTransactionTypes"
          label={t(
            'transactionsManagement.transactions.list.filters.transactionType'
          )}
          placeholder={t(
            'transactionsManagement.transactions.list.filters.all'
          )}
          value={
            filters.transactionTypes.length
              ? t(
                  'transactionsManagement.transactions.list.filters.numberSelected',
                  { totalItems: filters.transactionTypes.length }
                )
              : ''
          }
          {...dropdownProps}
        />
      )}
    >
      <CheckboxList
        items={items}
        filters={filters.transactionTypes}
        onItemToggle={itemToggle}
        totalItems={filters.transactionTypes.length}
      />
    </DropdownFilter>
  );
};
